define('popover-binder',['require','knockout','lodash'],function (require) {
    var ko = require('knockout');
    var _ = require('lodash');

    // custom binder to handle bootstrap popovers and
    // allow templates to be used for content
    ko.bindingHandlers.popover = {
        init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
            var options = ko.unwrap(valueAccessor());
            var contains = function ($container, contained) {
                if ($container && $container.length) {
                    var container = $container.get(0);

                    if (container === contained || $.contains(container, contained)) {
                        return true;
                    }
                }

                return false;
            };

            $(element).popover(options);

            $(element).click(function () {
                if (!ko.utils.unwrapObservable(valueAccessor())) {
                    return;
                }

                if ($(element).hasClass('popover-visible')) {
                    $(element).popover('hide').removeClass('popover-visible');
                } else {
                    $('.popover-visible').popover('hide');
                    $(element).popover('show').addClass('.popover-visible');
                }
            });

            $('body').on('click.ko-popover', function (evt) {
                var tip = $(element).data('bs.popover');

                if (!contains(tip, evt.target) && !contains($(element), evt.target)) {
                    $(element).popover('hide');
                }
            });

            $(element).on('show.bs.popover', function () {
                $(element).addClass('popover-visible');
                // hide popover on window resize
                var hidePopovers = _.debounce(function () {
                    $(element).popover('hide');
                });
                $(window).resize(hidePopovers);
            });

            $(element).on('shown.bs.popover', function () {
                /* eslint-disable newline-per-chained-call */
                ko.applyBindings(viewModel, $(element).data('bs.popover').tip().find('.popover-content').get(0));
                /* eslint-enable */
            });

            $(element).on('hidden.bs.popover', function () {
                var tip = $(element).data('bs.popover').tip();

                // hide any visible tool-tips
                $('.tooltip').hide();

                $(element).removeClass('popover-visible').data('bs.popover').$tip = null;

                tip.remove();
            });

            return {controlsDescendantBindings: true};
            // Fixes IE8 throwing a "cannot apply bindings multiple times"
            // exception
        }
    };

    /**
     * Use as a Knockout binding to create a popover around an element:
     * <div data-bind="popoverTarget: options"></div>
     *
     * Register standard standard Bootstrap Popover options as an object.
     * Additional options: onHide, onHidden, onShow, onShown, callback functions that will be registered.
     */
    ko.bindingHandlers.popoverTarget = {
        init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
            // Popover options specified in the view and applied here
            var options = ko.unwrap(valueAccessor());
            $(element).popover(options);
            // Register callback functions
            $(element).on('hide.bs.popover', options.onHide);
            $(element).on('hidden.bs.popover', options.onHidden);
            $(element).on('show.bs.popover', options.onShow);

            // Apply Knockout bindings and execute the shown callback function because both use 'shown.bs.popover'.
            $(element).on('shown.bs.popover', function () {
                // Removes Knockout bindings first to prevent multiple bindings exception
                // Possibly not kosher, cleanNode is internal Knockout API
                /* eslint-disable newline-per-chained-call */
                ko.cleanNode($(element).data('bs.popover').tip().find('.popover-content').get(0));
                ko.applyBindings(viewModel, $(element).data('bs.popover').tip().find('.popover-content').get(0));
                /* eslint-enable */

                if (options.onShown) {
                    options.onShown();
                }
            });
        }
    };

    /**
     * Use in lieu of the standard Bootstrap popover function: $(element).popover(options).
     * Wraps that functionality so that Knockout bindings are applied.
     *
     * Register standard standard Bootstrap Popover options as an object.
     * Additional options: onHide, onHidden, onShow, onShown, callback functions that will be registered.
     */
    var bindPopover = function (element, options, viewModel) {
        $(element).popover(options);
        // Register callback functions
        if (options) {
            $(element).on('hide.bs.popover', options.onHide);
            $(element).on('hidden.bs.popover', options.onHidden);
            $(element).on('show.bs.popover', options.onShow);
        }

        // Apply Knockout bindings and execute the shown callback function because both use 'shown.bs.popover'.
        $(element).on('shown.bs.popover', function () {
            // Removes Knockout bindings first to prevent multiple bindings exception
            // Possibly not kosher, cleanNode is internal Knockout API
            /* eslint-disable newline-per-chained-call */
            ko.cleanNode($(element).data('bs.popover').tip().find('.popover-content').get(0));
            ko.applyBindings(viewModel, $(element).data('bs.popover').tip().find('.popover-content').get(0));
            /* eslint-enable */

            if (options && options.onShown) {
                options.onShown();
            }
        });
    };

    /*
     * If useLayer is set to true, insert or remove a transparent backdrop.
     * Be sure to set the target "position" style correctly so z-indexing works.
     */
    var backdropHtml = '<div class="modal-backdrop fade in"></div>';

    var show = function (target, useLayer) {
        if (useLayer) {
            $(target).css('z-index', '1041');
            $('body').append(backdropHtml);
        }
        $(target).popover('show');
    };

    var hide = function (target, useLayer) {
        if (useLayer) {
            $(target).css('z-index', 'auto');
            var backdropElements = $('.modal-backdrop');
            if (backdropElements.length > 0) {
                // Complexity here necessary for IE8 compatibility.
                // remove() fails, but removeChild() doesn't.
                backdropElements[0].parentNode.removeChild(backdropElements[0]);
            }
        }
        $(target).popover('hide');
    };

    var isVisible = function (target) {
        /* eslint-disable newline-per-chained-call */
        return $(target).data('bs.popover').tip().hasClass('in');
        /* eslint-enable */
    };

    var toggle = function (target, useLayer) {
        if (isVisible(target)) {
            hide(target, useLayer);
        } else {
            show(target, useLayer);
        }
    };

    var swap = function (hideTarget, showTarget, useLayer) {
        hide(hideTarget, useLayer);
        show(showTarget, useLayer);
    };

    return {
        bindPopover: bindPopover,
        show: show,
        hide: hide,
        toggle: toggle,
        swap: swap,
        isVisible: isVisible
    };
});

